export default __webpack_public_path__ + "static/applause-79844fdca596cdd2e52bb77ec06b654a.mp3";